import { maxLength, minLength, prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "./case";
import { Capability } from "../../common/_types/capability";
import { CaseServiceReason } from "./case-service-reason";
import { Worker } from "../../workers/_types/worker";
import { CaseServiceCause } from "./case-service-cause";
import { Equipment } from "../../equipments/_types/equipment";
import { CaseNotificationNumber } from "./case-notification-number";
import { CaseServiceMaterial } from "./case-service-material";

export class CaseService extends Resource {
    public override type = 'caseServices';

    @prop()
    @required()
    public caseId!: string;

    public case?: Case;

    @prop()
    @required()
    public date = new Date();

    @prop()
    public estimatedDateEnd!:Date;

    @prop()
    public dateStart!: Date;

    @prop()
    public dateEnd!: Date;

    @prop()
    @required()
    public isConfirmed: boolean = false;

    @prop()
    @required()
    public isUrgent: boolean = false;

    @prop()
    @required()
    public isNotScheduled: boolean = false;

    @prop()
    @required()
    public notModify: boolean = false;

    @prop()
    @required()
    public isValidated: boolean = false;

    @prop()
    @required()
    public companyJobsNoRequired: boolean = false;

    @prop()
    @required()
    public workerJobsNoRequired: boolean = false;

    @prop()
    @required()
    public capabilityId!: string;

    public capability?: Capability;

    @prop()
    @required()
    public workerId!: string | null;

    public worker?: Worker;

    @prop()    
    public clientId!: string | null;

    @prop()
    public clientAddressId!: string | null;

    @prop()    
    public affectedId!: string | null;

    @prop()
    public affectedAddressId!: string | null;

    @prop()
    public target!: string;

    @prop()
    public reclamationType?: string | null;

    @prop()
    @minLength({ value: 25 })    
    @maxLength({value: 2000})
    public notes!: string;

    @prop()
    public economicNotes!: string;

    @prop()
    @maxLength({value: 2000})
    public pendingTasksDescription!: string;

    @prop() 
    @maxLength({value: 2000})
    public realizedTasksDescription!: string;

    @prop()    
    public transactionId!: string;
    
    /// <summary>
    /// Notas del motivo de cancelación
    /// </summary>
    @prop()
    public cancelCaseServiceReasonNotes?:string | null;

    @prop()
    @required()
    public isCancelled: boolean = false;
    
    @prop()
    public cancelCaseServiceReasonId?: string | null;

    @prop()
    public isGuard: boolean = false;

    @prop()
    @minLength({ value: 25 })
    public delayedCaseServiceReasonNotes?:string | null;

    @prop()
    public delayedCaseServiceReasonId?: string | null;


    @prop()
    public delayedCaseServiceCauseId?: string | null;

    
    @prop()
    @required()
    public isBudgetRequired: boolean = false;


    @prop()
    public workerBudgetTransactionId?: string | null;
    
    @prop()
    public clientSignatureDenied?: boolean | null;

    @prop()
    public clientSignatureDeniedReason?: string | null;

    @prop()
    public signatureId?:string | null;


    @prop()
    public equipmentId?: string | null;
    
    public equipment?: Equipment;

    /**
     * Materiales a retirar de oficina. Se envia poblado en el POST de creacion para que el backend
     * los replique en cada cita generada; en lectura llega via include.
     */
    public materials?: CaseServiceMaterial[];
    
    @prop()
    public cancelCaseServiceCauseId?: string | null;
    
    public cancelCaseServiceCause?: CaseServiceCause;


    @prop()
    public isLocked: boolean = false;

    @prop()
    public allowRegisterDataOffTheClock: boolean = false;

    @prop()
    public workerAttendanceStatus: string = 'pending';
    @prop()
    public workerAttendanceStatusNotes?: string = '';

    @prop()
    public latitudeStart?: number;
    @prop()
    public longitudeStart?: number;
    @prop()
    public latitudeEnd?: number;
    @prop()
    public longitudeEnd?: number;

    @prop()
    public isFailed: boolean = false;

    @prop()
    public caseNotificationNumberId?: string;
    public caseNotificationNumber?: CaseNotificationNumber;


    public files?: any[];

    

    
    @prop()
    public secondsFromWorkerLastCaseService?: number;
    
    @prop()
    public secondsToWorkerStartAddress?: number;

}